export default __webpack_public_path__ + "static/media/guests.c14cf0da.svg";